import {
	Box,
	Button,
	Container,
	Paper,
	Typography,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	TableRow,
	TableCell
} from '@mui/material';
import { Add, Search } from '@mui/icons-material';
import Pagination from '@mui/material/Pagination';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Placeholder, Subheader } from 'components';
import SearchForm from 'features/videos/SearchForm';
import VideoItem from 'features/videos/VideoItem';
import { useAlerts, useNavigation, useSelected, useVideos } from 'hooks';

const TABLE_HEADERS = [
	{
		value: 'image_url',
		label: 'Image',
		sortable: false,
		hidden: false
	},
	{
		value: 'user_id',
		label: 'User',
		sortable: false,
		hidden: false
	},
	{
		value: 'tags',
		label: 'Tags',
		sortable: false,
		hidden: false
	}
];

const VideoList = ({ ...props }) => {
	const navigate = useNavigate();
	const {
		isLoading,
		isEmpty,
		videos,
		findVideos,
		deleteVideo,
		paginate,
		params,
		page,
		numPages,
		reloadVideos,
		sortKey,
		sortDirection,
		handleSort
	} = useVideos({});

	const { handleClick, handleEditClick, handleAddClick } = useNavigation({
		history,
		url: '/videos'
	});

	const { selectedIds, handleSelect } = useSelected();

	const { showAlertSuccess } = useAlerts();

	const handleDeleteClick = async (video) => {
		await deleteVideo(video);
		showAlertSuccess('Video has been deleted');
		reloadVideos();
	};

	useEffect(() => {
		findVideos(
			{
				...params,
				sort_key: sortKey,
				sort_direction: sortDirection
			},
			page
		);
	}, [page, sortKey, sortDirection]);

	return (
		<>
			<Subheader
				title="Videos"
				buttons={[
					<Button
						variant="contained"
						startIcon={<Add />}
						onClick={handleAddClick}
					>
						Video
					</Button>
				]}
			/>
			<Container maxWidth="lg">
				<Paper>
					<SearchForm
						isLoading={isLoading}
						params={params}
						handleSearch={findVideos}
					/>
					{!isEmpty ? (
						<TableContainer component={Paper} elevation={0}>
							<Table>
								<TableHead>
									<TableRow sx={{ backgroundColor: '#FFF' }}>
										{TABLE_HEADERS.filter((h) => !h.hidden).map(
											(header, idx) => (
												<TableCell key={idx}>
													<Typography
														variant="subtitle2"
														color="primary"
														onClick={() =>
															header.sortable &&
															handleSort(`videos.${header.value}`)
														}
														sx={{
															cursor: header.sortable ? 'pointer' : 'default',
															'&:hover': {
																color: 'primary.main'
															}
														}}
													>
														{header.label}
													</Typography>
												</TableCell>
											)
										)}
										<TableCell align="right" />
									</TableRow>
								</TableHead>
								<TableBody>
									{videos.map((video) => (
										<VideoItem
											key={video.id}
											video={video}
											isSelectable={false}
											selectedIds={selectedIds}
											handleSelect={handleSelect}
											handleClick={handleClick}
											handleDeleteClick={handleDeleteClick}
											handleEditClick={handleEditClick}
										/>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					) : (
						<Placeholder
							icon={<Search />}
							title="No videos"
							subtitle="Please try another search"
						/>
					)}
				</Paper>
				{!isEmpty && (
					<Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
						<Pagination
							onChange={(ev, page) => paginate(page)}
							color="primary"
							size="small"
							shape="rounded"
							page={page}
							count={numPages}
						/>
					</Box>
				)}
			</Container>
		</>
	);
};

export default VideoList;
